import { AddToBasketData, ArticleOptionsSelectedService, ArticleOptionsServices } from '../../global';
import { notNullQuerySelector } from '../../_common/client/dom-helper';
import { BaseComponent2 } from '../../_common/client/base-component2';

export class OffersOrderingComponent extends BaseComponent2 {
    public readonly rootSelector = '.js_of_offers-ordering';
    private readonly orderingButtonSelector = '.js_of_offers-ordering__button';
    private selectedServices: ArticleOptionsSelectedService[] = [];
    private variationId = '';

    public async init(): Promise<void> {
        this.variationId = this.getRootElement().dataset?.variationId ?? '';
        this.registerArticleOptionsSelectionChangedEvent();
    }

    public async onReloadComponentEvent(): Promise<void> {
        this.resetSelectedServicesState();
        this.registerClickHandler();
    }

    private createAddToBasketData(): AddToBasketData {
        const trackingObject = this.createAddToBasketTrackingObject();
        const addToBasketData: AddToBasketData = {
            variationId: this.variationId,
            quantity: this.getQuantityValue(),
            itemOrigin: 'offersPage',
            services: this.selectedServices,
            ...trackingObject,
        };

        const enteredArticleNumberAndPromotion = this.getRootElement().getAttribute('data-entered-article-number-and-promotion');
        if (enteredArticleNumberAndPromotion) {
            addToBasketData.enteredArticleNumberAndPromotion = enteredArticleNumberAndPromotion;
        }
        return addToBasketData;
    }

    private createAddToBasketTrackingObject() {
        const availabilityTrackingDataJsonString = this.getRootElement().querySelector('#availabilityTrackingData')?.textContent;
        const availabilityTracking = availabilityTrackingDataJsonString ? JSON.parse(availabilityTrackingDataJsonString) : {};
        const offerScoreTrackingDataJsonString = this.getRootElement().querySelector('#offerScoreTrackingData')?.textContent;
        const offerScoreTracking = offerScoreTrackingDataJsonString ? JSON.parse(offerScoreTrackingDataJsonString) : {};
        return {
            tracking: {
                ...availabilityTracking,
                ...offerScoreTracking,
            },
        };
    }

    private callAddToBasketApi(addToBasketData: AddToBasketData): void {
        if (!window.o_order?.api?.addToBasket) {
            this.logger?.logError({
                message: 'Error adding to basket',
                error: new Error(`no ad to baskt available on pdp with url`),
            });
        }
        window.o_order?.api?.addToBasket(addToBasketData);
    }

    private async handleClickEvent(mouseEvent: MouseEvent): Promise<void> {
        mouseEvent.preventDefault();
        mouseEvent.stopPropagation();

        const addToBasketData = this.createAddToBasketData();
        this.callAddToBasketApi(addToBasketData);
    }

    private getButtonElement(): HTMLElement {
        return notNullQuerySelector(this.orderingButtonSelector, this.rootElement);
    }

    private getQuantityElement(): HTMLSelectElement {
        return this.getRootElement().querySelector('.js_of_offers-ordering__quantity') as HTMLSelectElement;
    }

    private getQuantityValue(): string {
        const quantityElement = this.getQuantityElement();
        return quantityElement ? quantityElement.options[quantityElement.selectedIndex].value : '1';
    }

    private registerClickHandler(): void {
        this.getButtonElement().addEventListener('click', async e => await this.handleClickEvent(e), false);
    }

    private registerArticleOptionsSelectionChangedEvent(): void {
        const articleOptionChangeCallback = (data: ArticleOptionsServices) => {
            this.selectedServices = data.services;
        };
        o_global.eventQBus.on(`ft5.offersArticleOptionChange.${this.variationId}`, articleOptionChangeCallback);
    }

    private resetSelectedServicesState(): void {
        this.selectedServices = [];
    }
}
